<div class="page">
  <h1 class="page-title" [class.blurred]="isFormOpen">Quest & Mindfulness Creation</h1>

  <div class="tab-buttons" [class.blurred]="isFormOpen">
    <button type="button"
            class="tab-button"
            [class.active]="selectedTab === 'quest'"
            [disabled]="isFormOpen"
            (click)="selectTab('quest')">
      Create new quest
    </button>
    <button type="button"
            class="tab-button"
            [class.active]="selectedTab === 'mindfulness'"
            [disabled]="isFormOpen"
            (click)="selectTab('mindfulness')">
      Create new mindfulness Sessions
    </button>
    <button type="button"
            class="tab-button"
            [class.active]="selectedTab === 'assign-quests'"
            [disabled]="isFormOpen"
            (click)="selectTab('assign-quests')">
      Assign Quests
    </button>
  </div>

  <div class="content-card">
    <ng-container *ngIf="selectedTab === 'quest'; else otherTabs">
      <app-create-quest
        (questCreated)="onQuestCreated()"
        (backClicked)="onBackToQuestTab()"
        (formOpened)="onFormOpened()"
      ></app-create-quest>
    </ng-container>
    <ng-template #otherTabs>
      <ng-container *ngIf="selectedTab === 'mindfulness'; else assignQuestsContent">
        <app-create-mindfulness-session
          (sessionCreated)="onSessionCreated()"
          (backClicked)="onBackToMindfulnessTab()"
          (formOpened)="onFormOpened()"
        ></app-create-mindfulness-session>
      </ng-container>
      <ng-template #assignQuestsContent>
        <app-assign-quests></app-assign-quests>
      </ng-template>
    </ng-template>
  </div>
</div>

